<template>
    <Header />
    <section class="contact--page">
        <div class="bloc--left">
            <img :src="illustration" alt="">
        </div>
        <div class="bloc--right">
            <form class="form--content_wrapper" @submit.prevent="handleSubmitContact" method="POST">

                <div v-if="message" class="alert alert-success alert-block">
                    <strong>{{ message }}</strong>
                </div>
                <h2>On prend contact?</h2><Loader v-if="isContactPending" class="base"/>
                <div class="name--form">
                    <div class="form--content">
                        <div class="material-textfield">
                            <input id="last_name" name="last_name" placeholder="" type="text" v-model="last_name">
                            <label for="last_name">Nom</label>
                        </div>
                        <div v-if="errors && errors.last_name" class="alert alert-danger">
                            <template v-for="error in errors.last_name">{{ error }}</template>
                        </div>
                    </div>
                    <div class="form--content">
                        <div class="material-textfield">
                            <input id="first_name" name="first_name" placeholder="" type="text" v-model="first_name">
                            <label for="first_name">Prénom</label>
                        </div>
                        <div v-if="errors && errors.first_name" class="alert alert-danger">
                            <template v-for="error in errors.first_name">{{ error }}</template>
                        </div>
                    </div>
                </div>
                <div class="name--form">
                    <div class="form--content">
                        <div class="material-textfield">
                            <input id="email" name="email" placeholder="" type="email" v-model="email">
                            <label for="email">Email</label>
                        </div>
                        <div v-if="errors && errors.email" class="alert alert-danger">
                            <template v-for="error in errors.email">{{ error }}</template>
                        </div>
                    </div>
                    <div class="form--content">
                        <div class="material-textfield">
                            <input id="phone" name="phone" placeholder="" type="text" v-model="phone">
                            <label for="phone">N° de téléphone</label>
                        </div>
                    </div>
                </div>
                <div class="content--form">
                    <div class="form--content">
                        <div class="material-textfield">
                            <textarea id="body" name="body" placeholder="" v-model="body" />
                            <label for="body">Votre message</label>
                        </div>
                        <div v-if="errors && errors.body" class="alert alert-danger">
                            <template v-for="error in errors.body">{{ error }}</template>
                        </div>
                    </div>
                </div>
                <div class="button--main">
                    <button type="submit" role="button" aria-label="Bouton envoyer le message" id="button--contact" class="btn--main">
                        Envoyer
                    </button>
                </div>
            </form>
            <div class="contact--infos">
                <h3><a href="tel:+3242403840"> +32 (0)4 240 38 40</a></h3>
                <h3><a href="mailto:info@miysis.be" target="_blank">info@miysis.be</a></h3>
                <h3><a href="https://goo.gl/maps/yoU1cUyf8E85YMuA9" target="_blank">
                    Rue de la Renaissance 1
                    <br/>
                    4451 Voroux-Lez-Liers
                </a>
                </h3>
            </div>
        </div>
    </section>
</template>

<script>
import Header from "../components/Header"
import Loader from "../components/partials/loader.vue";

export default {
    beforeMount() {
        !this.isPageAvailable() ? this.$router.push('/') : ''
    },
    data() {
        return {
            email: '',
            last_name: '',
            first_name: '',
            phone: '',
            body: ''
        }
    },
    computed: {
        errors() {
            return this.$store.state.frontoffice.errors;
        },
        message() {
            return this.$store.state.frontoffice.message;
        },
        isContactPending() {
            return this.$store.state.frontoffice.isContactPending;
        },
        illustration() {
            if(this.$store.state.frontoffice.domain && this.$store.state.frontoffice.domain.settings && this.$store.state.frontoffice.domain.settings.data.find( (setting) => setting.name === 'contact-image') && this.$store.state.frontoffice.domain.settings.data.find( (setting) => setting.name === 'contact-image').image) {
                return this.$store.state.frontoffice.domain.settings.data.find( (setting) => setting.name === 'contact-image').image.url
            }

            return '../img/landing-img.png';
        }
    },
    methods: {
        handleSubmitContact() {
            this.$store.dispatch('frontoffice/postContact', {
                last_name: this.last_name,
                first_name: this.first_name,
                email: this.email,
                phone: this.phone,
                body: this.body
            })
        },
        isPageAvailable() {
            if(this.$store.state.frontoffice.domain.pages.data && this.$store.state.frontoffice.domain.pages.data.find( page => page.name === this.$route.name)) {
                return !!Number(this.$store.state.frontoffice.domain.pages.data.find( page => page.name === this.$route.name).is_active)
            }

            return true;
        }
    },
    components: {
        Header,
        Loader
    }
}
</script>
